var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      staticClass: "container flex",
      attrs: { "data-title": "邀请教师" }
    },
    [
      _c("div", { staticClass: "white-container flex column cross-center" }, [
        _c(
          "div",
          {
            staticClass: "user-portrait-container flex main-center cross-center"
          },
          [
            _c("van-image", {
              staticClass: "user-portrait",
              attrs: {
                round: "",
                width: "60px",
                height: "60px",
                src: _vm.user.avatar
              },
              on: { error: _vm.onImageError }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "user-name" }, [
          _vm._v(_vm._s(_vm.user.username))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-container" }, [
          _c(
            "div",
            {
              staticClass: "flex main-center",
              staticStyle: { "margin-top": "22px" }
            },
            [
              _c("div", { staticClass: "flex column main-center input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mobile,
                      expression: "mobile"
                    }
                  ],
                  attrs: { type: "tel", placeholder: "请输入手机号" },
                  domProps: { value: _vm.mobile },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.mobile = $event.target.value
                    }
                  }
                })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex main-center",
              staticStyle: { "margin-top": "10px" }
            },
            [
              _c("div", { staticClass: "flex cross-center input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.code,
                      expression: "code"
                    }
                  ],
                  staticStyle: { width: "50px" },
                  attrs: { type: "tel", placeholder: "请输入验证码" },
                  domProps: { value: _vm.code },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.code = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticStyle: {
                    width: "1px",
                    height: "14px",
                    background: "#c2c2c2ff"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "verfityCode",
                    style: { color: _vm.codeTextColor },
                    on: { click: _vm.onSendCodeEvent }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.codeText) + "\n          "
                    )
                  ]
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "register-button ripple flex main-center cross-center",
            on: { click: _vm.onRegisterEvent }
          },
          [_c("span", [_vm._v("立即注册")])]
        ),
        _vm._v(" "),
        _c("img", {
          staticStyle: {
            "margin-left": "10%",
            "margin-top": "20px",
            width: "239px",
            height: "47px"
          },
          attrs: { src: require("../../../assets/invitation/yueban-logo.png") }
        })
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticStyle: { "background-color": "rgba(0, 0, 0, 0.0)" },
          attrs: { "close-on-click-overlay": _vm.overlay },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c("invitation-success-alert", {
            attrs: { detailTitle: "下载阅伴教师端App，马上开启班级共读活动。" },
            on: { onClose: _vm.onCloseAlert, onDownloadApp: _vm.onDownloadApp }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom-bg" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/invitation/Invitation-bottom-bg.png")
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16a54a20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16a54a20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/invitation/teacher/InvitationTeacher.vue
// module id = null
// module chunks = 